<template>
  <div class="mb-3 card mb-lg-5">
    <modal-delete-confirmation
      v-if="showDeleteModal"
      @close="showDeleteModal = false"
      @cancel="showDeleteModal = false"
      @delete="
        deleteCampaigns()
        showDeleteModal = false
      "
    />
    <div class="card-header">
      <div class="row justify-content-between align-items-center flex-grow-1">
        <div class="col-6">
          <div class="row align-items-sm-center">
            <div class="col-sm-auto">
              <div class="mr-2 d-flex align-items-center">
                <span class="mr-2 text-secondary">Status:</span>

                <!-- Select -->
                <select
                  class="js-select2-custom js-datatable-filter custom-select"
                  size="1"
                  style="opacity: 0"
                  data-target-name="is_active"
                  data-hs-select2-options='{
                                "minimumResultsForSearch": "Infinity",
                                "dropdownAutoWidth": true,
                                "width": true
                              }'
                >
                  <option value="">All</option>
                  <option value="true">Active</option>
                  <option value="false">Passive</option>
                </select>
                <!-- End Select -->
              </div>
            </div>

            <div class="col-md">
              <form>
                <!-- Search -->
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="tio-search"></i>
                    </div>
                  </div>
                  <input
                    id="searchInput"
                    @keyup="search"
                    type="search"
                    class="form-control"
                    placeholder="Search"
                    aria-label="Search users"
                  />
                </div>
                <!-- End Search -->
              </form>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="d-flex justify-content-end">
            <div id="datatableCounterInfo" style="display: none">
              <div class="d-flex align-items-center">
                <span class="mr-3 font-size-sm"> <span id="datatableCounter">0</span> Selected</span>
                <a class="btn btn-sm btn-outline-danger" href="javascript:;" @click="showDeleteModal = true">
                  <i class="tio-delete-outlined"></i> Delete
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <datatable-table-element
      :multiselect="true"
      :heads="[
        { class: 'table-column-right-aligned', text: '' },
        { class: '', text: 'Name' },
        { class: 'table-column-right-aligned', text: 'Impressions' },
        { class: 'table-column-right-aligned', text: 'Actions' },
        { class: 'table-column-right-aligned', text: 'Date Created' },
        { class: '', text: '' }
      ]"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import advancedSelectMixin from "@/mixins/advanced-select-mixin"
import dateFormatterMixin from "@/mixins/date-formatter-mixin"
import createSvg from "@/theme-files/assets/svg/illustrations/create.svg"
import campaignAPI from "@/api/campaign"
import { debounce } from "lodash"
import ModalDeleteConfirmation from "@/components/modals/ModalDeleteConfirmation"
import DatatableTableElement from "@/components/common/DatatableTableElement"

export default {
  name: "CampaignsTable",
  components: { DatatableTableElement, ModalDeleteConfirmation },
  computed: mapState("sites", ["selectedSite"]),
  data() {
    return {
      datatable: null,
      showDeleteModal: false,
      isActive: null
    }
  },
  mixins: [advancedSelectMixin, dateFormatterMixin],
  methods: {
    ...mapActions("campaigns", ["fetchCampaignsOfCurrentSite", "updateCampaignStatus"]),
    async changeCampaignStatus(inp) {
      inp.disabled = true
      const campaignId = inp.dataset["campaignId"]
      const checked = inp.checked
      try {
        await this.updateCampaignStatus({ campaignId, status: checked })
      } catch (e) {
        inp.checked = !inp.checked
      } finally {
        inp.disabled = false
      }
    },
    async deleteCampaigns() {
      const ids = []
      this.datatable.rows({ selected: true }).every(function () {
        const id = this.data().id
        ids.push(id)
      })

      await campaignAPI.deleteCampaigns({ siteId: this.selectedSite.id, campaignIds: ids })
      this.datatable.ajax.reload()
      $("#datatableCounterInfo").hide()
      $("#datatableCheckAll").prop("checked", false)
    },
    search: debounce(function (e) {
      this.datatable.column(2).search(e.target.value).draw()
    }, 200)
  },
  async mounted() {
    const vm = this
    this.initAdvancedSelect()
    const url = campaignAPI.getCampaignsDatatablesEndpoint({ siteId: this.selectedSite.id })
    require("@/theme-files/hs.datatables")
    this.datatable = $.HSCore.components.HSDatatables.init($("#datatable"), {
      processing: true,
      serverSide: true,
      select: {
        style: "multi",
        selector: "td:first-child input[type='checkbox']",
        classMap: {
          checkAll: "#datatableCheckAll",
          counter: "#datatableCounter",
          counterInfo: "#datatableCounterInfo"
        }
      },
      drawCallback: function () {
        vm.$el.querySelectorAll(".toggle-switch-input").forEach((inp) => {
          inp.addEventListener("change", () => vm.changeCampaignStatus(inp))
        })

        vm.$el.querySelectorAll("button[data-leads-for]").forEach((btn) => {
          btn.addEventListener("click", () => {
            vm.$router.push({ name: "Dashboard.Leads", query: { campaignId: btn.dataset.leadsFor } })
          })
        })
        const firstCampaignBtn = vm.$el.querySelector("button#create-first-campaign")
        if (firstCampaignBtn) {
          firstCampaignBtn.addEventListener("click", () => {
            vm.$router.push({ name: "Dashboard.Campaigns.Create" })
          })
        }
        vm.$el.querySelectorAll(".redirect-to-summary").forEach((btn) => {
          btn.addEventListener("click", () => {
            vm.$router.push({ name: "Dashboard.Campaigns.Summary", params: { id: btn.dataset.campaignId } })
          })
        })
        vm.$el.querySelectorAll(".screenshot-loading").forEach((loadingElement) => {
          const campaignId = loadingElement.dataset.campaignId
          const parent = loadingElement.closest(".redirect-to-summary")
          const checkerFunc = async () => {
            const response = await campaignAPI.fetchCampaign({ siteId: vm.selectedSite.id, campaignId: campaignId })
            const ssUrl = response.data.data.campaign.variants[0]["ss_url"]
            if (ssUrl) {
              loadingElement.remove()
              parent.insertAdjacentHTML(
                "afterbegin",
                // `<div class="mr-3 avatar avatar-xl" style="width: auto;aspect-ratio: 16 / 9;"><img class="border avatar-img" src="${ssUrl}"></div>`
                `<div class="mr-3 avatar avatar-xl" style="width: auto;aspect-ratio: 16 / 9;"><img class="border avatar-img" src="https://socialistmodernism.com/wp-content/uploads/2017/07/placeholder-image.png"></div>`
              )
              clearInterval(checkingInterval)
            }
          }

          const checkingInterval = setInterval(checkerFunc, 3000)
        })
      },
      ajax: {
        url: url,
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("access_token")
        },
        data: function (params) {
          if (vm.isActive !== null) {
            params.isActive = vm.isActive
          }
          return params
        },
        dataSrc: function (json) {
          for (var i = 0, ien = json.data.length; i < ien; i++) {
            json.data[i]["checkbox"] = `<div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="campaign${json.data[i].id}">
                <label class="custom-control-label" for="campaign${json.data[i].id}"></label>
              </div>`

            json.data[i]["is_active"] = `<label class="toggle-switch toggle-switch-sm d-flex align-items-center" for="campaignStatusToggle${
              json.data[i].id
            }">
              <input type="checkbox" id="campaignStatusToggle${json.data[i].id}" data-campaign-id="${
              json.data[i].id
            }" class="toggle-switch-input campaign-status-changer" ${json.data[i].is_active ? "checked" : ""}>
              <span class="toggle-switch-label">
                <span class="toggle-switch-indicator"></span>
              </span>
            </label>`

            const name = json.data[i].name
            json.data[i][
              "name"
            ] = `<a href="javascript:;" class="media align-items-center redirect-to-summary" data-campaign-id="${json.data[i].id}">`
            if (json.data[i].screenshot_url) {
              json.data[i][
                "name"
              ] += `<div class="mr-3 avatar avatar-xl" style="width: auto;aspect-ratio: 16 / 9;"><img class="border avatar-img" src="https://socialistmodernism.com/wp-content/uploads/2017/07/placeholder-image.png"></div>`
            } else {
              json.data[i][
                "name"
              ] += `<div class="mr-3 d-flex justify-content-center align-items-center avatar-xl screenshot-loading" data-campaign-id="${json.data[i].id}" style="width: auto;aspect-ratio: 16 / 9;"><div class="mx-auto spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></div>`
            }
            json.data[i]["name"] += `<div class="media-body"><span class="mb-0 h5 text-hover-primary">${name}</span></div>
            </a>`
            json.data[i]["impression"] = `<div class="text-right">${json.data[i]["impression"]}</div>`
            json.data[i]["action"] = `<div class="text-right">${json.data[i]["action"]}</div>`
            json.data[i]["created_at"] = `<div class="text-right">${vm.getFormattedDate(json.data[i]["created_at"])}</div>`

            json.data[i]["actions"] = `<button class="p-0 btn" data-leads-for="${json.data[i].id}">
              <i class="tio tio-group-equal"></i><br><span>Leads</span>
            </button>`
          }

          return json.data
        }
      },
      columns: [
        { data: "checkbox" },
        { data: "is_active" },
        { data: "name" },
        { data: "impression" },
        { data: "action" },
        { data: "created_at" },
        { data: "actions" }
      ],
      columnDefs: [
        { orderable: false, targets: [0, 1, 2, -1] },
        { className: "table-column-pr-0", targets: [0, 1] }
      ],
      order: [[5, "desc"]],
      language: {
        zeroRecords: `<div class="py-6 d-flex flex-column align-items-center">
            <img class="mb-5 img-fluid" src="${createSvg}" style="max-width: 14rem;">
            <h1>Let's Create First Campaign!</h1>
            <p class="mb-4">
              Increase visitor happiness, collect leads, create gamification scenarios...
            </p>
            <button class="btn btn-primary" id="create-first-campaign">Create My First Campaign</button>
          </div>`,
        processing: `<div class="my-4 d-flex justify-content-center">
  <div class="mx-auto spinner-border text-info" role="status">
    <span class="sr-only">Loading...</span> </div></div>`
      }
    })

    $(".js-datatable-filter").on("change", function () {
      var $this = $(this)
      let search = $this.val()
      if (search === "true") vm.isActive = 1
      else if (search === "false") vm.isActive = 0
      else vm.isActive = null
      vm.datatable.ajax.reload()

      // vm.datatable.column(1).search(search).draw()
    })
  }
}
</script>
